export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&_]{5,20}$/;

export const passwordErrorMessage = "Password must be 5–20 characters and include at least one uppercase letter, one lowercase letter, one digit, and one special character (@$!%*?&). Underscore (_) is allowed.";

export const validatePassword = (password: string): { valid: boolean; error?: string } => {
  if (!password) {
    return { valid: false, error: 'Password is required' };
  }
  if (!passwordRegex.test(password)) {
    return { valid: false, error: passwordErrorMessage };
  }
  return { valid: true };
};
